import srSdk from '../../../services/registration-sdk';

/*******************************************************************************
 * Initial state
 */
const initialState = {
  forms: [],
  formsLoading: false,
  formsLoadingError: null,
  form: {},
  formLoading: false,
  formLoadingError: null
};

/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'registration/setState';

/*******************************************************************************
 * Reducer
 */
export default function registrationReducer( state = initialState, action ) {
  switch ( action.type ) {
    case SET_STATE: {
      return {
        ...state,
        ...action.state
      };
    }
    default:
      return state;
  }
}

/*******************************************************************************
 * Action creators
 */
function setState( state ) {
  return {
    type: SET_STATE,
    state
  };
}

function loadForms( regId ) {
  return dispatch => {
    if ( regId ) {
      dispatch(
        setState( {
          formsLoading: true,
          formsLoadingError: null
        } )
      );
      srSdk
        .getForms( regId )
        .then( data => {
          const { forms } = data;
          dispatch(
            setState( {
              forms,
              formsLoading: false
            } )
          );
        } )
        .catch( err => {
          dispatch(
            setState( {
              formLoading: false,
              formsLoadingError: err
            } )
          );
        } );
    }
  };
}
function loadFormById( formId, regId ) {
  return dispatch => {
    if ( regId ) {
      dispatch(
        setState( {
          formLoading: true,
          formLoadingError: null
        } )
      );

      srSdk
        .getForm( formId, regId )
        .then( form => {
          dispatch(
            setState( {
              form,
              formLoading: false
            } )
          );
        } )
        .catch( err => {
          dispatch(
            setState( {
              formLoading: false,
              formLoadingError: err
            } )
          );
        } );
    }
  };
}

function clearForms() {
  return dispatch => {
    initialState.forms = [];
    dispatch(
      setState( {
        ...initialState
      } )
    );
  };
}

function clearForm() {
  return dispatch => {
    initialState.form = {};

    dispatch(
      setState( {
        ...initialState
      } )
    );
  };
}

export const actions = {
  loadForms,
  loadFormById,
  clearForms,
  clearForm
};
